import axiosInstance from './axios-instance';

// Fetcher genérico do SWR (Req 2.1/2.2/2.3): delega a key, sem reescrevê-la, à
// instância da Task 2 e devolve apenas o corpo. Sem try/catch — a rejeição do
// axios sobe pelo await para o SWR expor via `error` (Req 2.5). T default = unknown
// para não forçar `any` no ponto de uso; cada hook informa o tipo via useSWR<T>.
export async function fetcher<T = unknown>(key: string): Promise<T> {
  const response = await axiosInstance.get<T>(key);
  return response.data;
}
